import React, { Component } from 'react';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { WithStyles, createStyles, Grid, Card, CardContent, Button, Typography, Checkbox, Paper } from '@material-ui/core';
import {
    NavigateBeforeOutlined as BackIcon,
} from '@material-ui/icons';


//components
import TemplateTypes from '../components/TemplateTypes';
import TemplateSetting from '../components/TemplateSetting';
import TemplateContent from '../components/TemplateContent';
import { getTypeOfGoal, getSubject, getContentSubType, getTestTemplateType, testTemplateList } from '../actions/testTemplateActions';
import { TestTemplateBody } from '../types/TestTemplateBody';
import { ContentSubType } from '../types/ContentSubTypeBody';

import { MyPATDialog, MyPATLink } from '../../common';
import urlService from '../../common/services/urlService';
import CustomInfoIcon from '../../common/CustomInfoIcon';
import ACLService from '../../acl/services/aclService';
import { AUTHORING_CONTENT_TYPES, CONTENT_SECTION_TYPES, MODULE_TO_TEST_MAP, MODULE_TO_TEST_PERMISSION_MAP, PERMISSION_CONTENT_TYPES, TEMPLATE_SETTING_FILTER_TYPES, TEST_TEMPLATE_TYPES, USER_RIGHTS } from '../../../constants/comman';
import { setActiveTestType } from '../types/TypeOfTestTemplateAction';


const styles = (theme: Theme) => createStyles({
    infoIcon: {
        position: 'relative',
        top: -2,
        zIndex: 9,
        '& second-child': {
            marginLeft: -105,
            top: 25
        },
        '& img':{
            width: 16,
        }
    },
    root: {
        flexGrow: 1,
    },
    contentFilter: {
        paddingTop: theme.spacing.unit * 2,
    },
    contentSelectAll: {
        opacity: 0.5,
        padding: '2px 4px 2px 0',
        marginTop: - theme.spacing.unit * 2,
        '& svg': {
            fontSize: '1.5rem'
        }
    },
    paddingLeft: {
        paddingLeft: theme.spacing.unit * 2
    },
    textRight: {
        textAlign: 'right',
    },
    inlineBlock: {
        display: 'inline-block'
    },
    cardHeigth: {
        minHeight: "100vh"
    },
    cursorPointer: {
        cursor: 'pointer',
    },
    backIconRoot: {
        fill: theme.palette.text.primary,
        fontSize: 18,
        fontWeight: 400,
        color: '#333',
        opacity: 0.5,
        marginBottom: 3,
        '& svg':{
            fill: '#333',
        },
    },
    headerTT: {
        background: theme.palette.common.white,
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        paddingLeft: theme.spacing.unit * 3,
        paddingRight: theme.spacing.unit * 3,
        // marginBottom: theme.spacing.unit * 2,
        boxShadow: '0 2px 20px 0 #0000001F',
    },
    container: {
        padding: theme.spacing.unit * 2,
    },
    tooltipIcon: {
        display: 'inline-block'
    },
    headingTxt:{
        fontSize: 24,
        fontWeight: 600,
        color: '#333',
        marginBottom: 20,
        display: 'inline-block'
    }
});


interface TestTemplateProps extends WithStyles<typeof styles> {
    getTypeOfGoal: (bucketType?: string) => void;
    getSubject: (id: any) => void;
    getContentSubType: (subContentType: string) => void;
    getTestTemplateType(subType: string, queryParam?: string): void
    testTemplateList(skip: number, type: string, typeId: string,searchQuery?:string): void,
    gotData: () => void,
    history: any,
    match: any,
    setActiveTestType: Function,
}


interface TestTemplateStates {
    filterTestTemplateList: TestTemplateBody[];
    testTemplateTypeList: ContentSubType[],
    selectedId: string;
    selectedTestTypeName: string;
    selectedTestSetting: any;
    backTo: string;
    skip: number;
    hasMoreData: boolean;
    currentTemplate: { type: string, typeId: string };
    recordCount: number;
    searchQuery:string;
    testTypesAccess: any[];
    selectedTestTypeFilter: string;
    templateTypesAccess: any[];
    selectedTemplateTypeFilter: string;
}

class TestTemplate extends Component<TestTemplateProps, TestTemplateStates>{


    constructor(props: TestTemplateProps) {
        super(props);
        const testTypesAccess = CONTENT_SECTION_TYPES.filter(section => { return ACLService.checkModulePermission(MODULE_TO_TEST_PERMISSION_MAP[section.value], USER_RIGHTS.CREATE) });
        const selectedTestType = testTypesAccess.length ? testTypesAccess[0].value : '';
        const templateTypesAccess = [];
        if([USER_RIGHTS.CREATE, USER_RIGHTS.VIEW].some(right => ACLService.checkModulePermission(PERMISSION_CONTENT_TYPES.DEFAULT_TEST_TEMPLATE, right))) {
            templateTypesAccess.push(TEST_TEMPLATE_TYPES.DEFAULT);
        }
        if([USER_RIGHTS.CREATE, USER_RIGHTS.VIEW].some(right => ACLService.checkModulePermission(PERMISSION_CONTENT_TYPES.CUSTOM_TEST_TEMPLATE, right))) {
            templateTypesAccess.push(TEST_TEMPLATE_TYPES.CUSTOM);
        }
        this.state = {
            filterTestTemplateList: [],
            testTemplateTypeList: [],
            selectedId: "",
            selectedTestTypeName: "",
            selectedTestSetting: {},
            backTo: "My Library",
            skip: 0,
            hasMoreData: true,
            currentTemplate: { type: '', typeId: '' },
            recordCount: 0,
            searchQuery:'',
            testTypesAccess: testTypesAccess,
            selectedTestTypeFilter: selectedTestType,
            templateTypesAccess: templateTypesAccess,
            selectedTemplateTypeFilter: templateTypesAccess[0] || '',
        };


        this.handleBack = this.handleBack.bind(this);
        this.handleNextPage = this.handleNextPage.bind(this);
        this.handlePrevPage = this.handlePrevPage.bind(this);
        this.toPage = this.toPage.bind(this);
    }

    async getTemplateAndRule() {
        let {testTypesAccess, templateTypesAccess, currentTemplate, skip,searchQuery, selectedTestTypeFilter, selectedTemplateTypeFilter } = this.state;
        let contentSubTypeList: any = [];
        if(testTypesAccess.length && templateTypesAccess.length) {
            contentSubTypeList = await this.props.getTestTemplateType(MODULE_TO_TEST_MAP[selectedTestTypeFilter], selectedTemplateTypeFilter);
        }
        contentSubTypeList = contentSubTypeList || [];
        if (contentSubTypeList.length > 0) {
            contentSubTypeList[0].isSelected = true
            this.props.setActiveTestType(contentSubTypeList[0]);
        }
        this.setState({ testTemplateTypeList: contentSubTypeList })
        const firstElement = _.get(contentSubTypeList, '0');
        currentTemplate = { type: firstElement && firstElement.code, typeId: firstElement && firstElement._id };
        this.activeTestType(firstElement && firstElement._id)
        let templateList: any = [];
        if (contentSubTypeList.length) {
            templateList = await this.props.testTemplateList(skip, '', currentTemplate.typeId,searchQuery);
        }
        const recordCountObj = templateList.pop()
        this.setState({ filterTestTemplateList: templateList, currentTemplate, ...recordCountObj })
        this.props.getTypeOfGoal(MODULE_TO_TEST_MAP[selectedTestTypeFilter]);
    }

    async componentDidMount() {
        const {selectedTestTypeFilter, selectedTemplateTypeFilter} = this.state;
        if (selectedTestTypeFilter && selectedTemplateTypeFilter) {
            await this.getTemplateAndRule()
        }
        this.props.getSubject("");
        await this.props.getContentSubType(AUTHORING_CONTENT_TYPES.GLORIFIRE_QUESTION);
        let { match, history } = this.props;
        let isRefUrl = !_.isEmpty(history.location.search) && history.location.search.search('refUrl') != -1 ? true : false;
        if (isRefUrl) {
            this.setState({ backTo: "Test" });
        }
        // window.addEventListener('scroll', this.handleNextPage);
    }

    async onFilterChanged(newFilter: any, type: string) {
        if (type === TEMPLATE_SETTING_FILTER_TYPES.TEST_TYPE) {
            this.setState({ selectedTestTypeFilter: newFilter }, () => {
                this.getTemplateAndRule();
            });
        } else {
            this.setState({ selectedTemplateTypeFilter: newFilter }, () => {
                this.getTemplateAndRule();
            });
        }
    }

    componentWillReceiveProps(nextProps: any) {
        this.setState({
            filterTestTemplateList: nextProps.listTestTemplate
        })
    }

    async handleNextPage() {
        let { currentTemplate, hasMoreData, skip,searchQuery } = this.state;
        skip += 10;
        let templateList: any = await this.props.testTemplateList(skip, '', currentTemplate.typeId,searchQuery);
        if (templateList.length < 10) {
            hasMoreData = false;
        }
        this.setState({ filterTestTemplateList: templateList, skip })
    }

    async handlePrevPage() {
        let { currentTemplate, hasMoreData, skip,searchQuery } = this.state;
        skip -= 10;
        let templateList: any = await this.props.testTemplateList(skip, '', currentTemplate.typeId,searchQuery);
        if (skip === 0) {
            const recordCountObj = templateList.pop()
            this.setState({ ...recordCountObj })
        }
        if (templateList.length < 10) {
            hasMoreData = false;
        }
        this.setState({ filterTestTemplateList: templateList, skip })
    }

    async toPage(page: number) {
        let { currentTemplate, hasMoreData, skip,searchQuery } = this.state;
        skip = 10 * page;
        let templateList: any = await this.props.testTemplateList(skip, '', currentTemplate.typeId,searchQuery);
        if (templateList.length < 10) {
            hasMoreData = false;
        }
        this.setState({ filterTestTemplateList: templateList, skip })
    }

    async changeCurrentTemplateType(type: string, typeId: string) {
        let { currentTemplate, hasMoreData, skip ,searchQuery} = this.state;
        currentTemplate = { type, typeId };
        skip = 0;
        hasMoreData = true;
        let templateList: any = await this.props.testTemplateList(skip, '', typeId,searchQuery);
        const recordCountObj = templateList.pop()
        this.setState({ ...recordCountObj })
        this.setState({ filterTestTemplateList: templateList, currentTemplate, skip })
    }

    async updateTestTemplateTypeList(type: string = '', typeId?: string) {
        let { testTemplateTypeList, currentTemplate, skip, selectedTestTypeFilter, selectedTemplateTypeFilter } = this.state;
        const contentSubTypeList: any = await this.props.getTestTemplateType(
            MODULE_TO_TEST_MAP[selectedTestTypeFilter], selectedTemplateTypeFilter
        );
        if (type === "add") {
            let templateList: any = await this.props.testTemplateList(skip, '', currentTemplate.typeId);
            const recordCountObj = templateList.pop()
            this.setState({ filterTestTemplateList: templateList, ...recordCountObj });
        } else {
            if (type == 'newTestType') {
                let currentIndex = 0
                contentSubTypeList.forEach((element: any, index: number) => {
                    if (element._id == typeId) {
                        currentIndex = index
                    }
                });
                contentSubTypeList[currentIndex].isSelected = true
                currentTemplate = { type: contentSubTypeList[currentIndex].code, typeId: contentSubTypeList[currentIndex]._id }
                let templateList: any = await this.props.testTemplateList(0,
                    '',
                    currentTemplate.typeId,
                );
                const recordCountObj = templateList.pop()
                this.setState({
                    filterTestTemplateList: templateList,
                    ...recordCountObj,
                    testTemplateTypeList: contentSubTypeList,
                    skip: 0,
                    currentTemplate
                });
                this.props.setActiveTestType(contentSubTypeList[currentIndex]);
                this.activeTestType(contentSubTypeList[currentIndex]._id)
            } else {
                let isSelectedIndex = 0
                testTemplateTypeList.forEach((element, index) => {
                    if (element.isSelected) {
                        isSelectedIndex = index
                    }
                });
                if (contentSubTypeList.length > 0 && type !== 'setting') {
                    if (contentSubTypeList[isSelectedIndex]) {
                        contentSubTypeList[isSelectedIndex].isSelected = true
                        this.activeTestType(contentSubTypeList[isSelectedIndex]._id)
                    } else {
                        contentSubTypeList[0].isSelected = true
                        this.activeTestType(contentSubTypeList[0]._id)
                    }
                }
                this.setState({ testTemplateTypeList: contentSubTypeList });
            }
        }
    }

    activeTestType(id: any) {
        if (this.state.filterTestTemplateList) {
            let { selectedTestSetting } = this.state
            let k = selectedTestSetting;

            //This is for page load show data defaut for subject
            k = k && k.testSection ? k.testSection : "subject";
            let sNameL: any = this.state.testTemplateTypeList.filter(o => o._id == id);
            selectedTestSetting = (sNameL.length && { testSection: _.lowerCase(sNameL[0].sectionLevel), code: sNameL[0].code }) || {}
            this.setState({
                selectedId: id,
                selectedTestSetting,
                selectedTestTypeName: sNameL && sNameL.length > 0 ? sNameL[0].name : ""
            });
        }
    }

    activeTestSetting(testS: any) {
        if (this.state.filterTestTemplateList) {
            let sId = this.state.selectedId;
            let f = [...this.state.filterTestTemplateList];
            let testSec = !testS ? "subject" : testS.testSection;
            f = f.filter(o => o.testTemplateTypeId == sId && o.testSectionLevel == testSec);
            this.setState({
                selectedTestSetting: testS,
                filterTestTemplateList: f
            })
        }

    }


    handleBack() {
        let { match, history } = this.props;
        let isRefUrl = !_.isEmpty(history.location.search) && history.location.search.search('refUrl') != -1 ? true : false;
        if (isRefUrl) {
            let url = urlService.getParams(history.location.search, 'refUrl');
            window.location.href = url;
            this.setState({ backTo: "Test" });
        } else {
            let isRefUrl = !_.isEmpty(history.location.search) && history.location.search.search('course') != -1 ? true : false;
            if (isRefUrl) {
                history.push('/course')
            } else {
                history.push('/mylibrary')
            }
        }
    }

    settingDataSet = () => {
        let returnData = false;
        let { testTemplateTypeList, selectedId } = this.state;
        let templateType: any = _.find(testTemplateTypeList, { _id: selectedId }) || {};
        if (!_.isEmpty(templateType) && templateType.hasOwnProperty('time') && templateType.time !== 0) {
            returnData = true;
        }
        return returnData;
    }

    onTemplateRuleEdit = () => {
        const { skip, currentTemplate, searchQuery } = this.state;
        this.props.testTemplateList(skip,'', currentTemplate.typeId, searchQuery);
    }

    isFieldDisabled = () => {
        const { filterTestTemplateList } = this.state
        let isDisabled = true;
        if (filterTestTemplateList.length == 0 && !this.settingDataSet()) {
            isDisabled = false;
        }

        return isDisabled;
    }
    handleSearchQuery= async(searchQuery:string)=>{
        let { currentTemplate, hasMoreData, skip } = this.state;
        skip = 0;
        let templateList: any = await this.props.testTemplateList(skip, '', currentTemplate.typeId,searchQuery);
        if (templateList.length < 10) {
            hasMoreData = false;
        }
        const recordCount = templateList.find((item: any) => item.hasOwnProperty('recordCount')).recordCount || 0;
        this.setState({ filterTestTemplateList: templateList, skip,searchQuery, recordCount })
    }

    render() {
        const { classes } = this.props;

        const {
            filterTestTemplateList,
            selectedId,
            selectedTestTypeName,
            selectedTestSetting,
            testTemplateTypeList,
            currentTemplate,
            recordCount,
            selectedTestTypeFilter,
            testTypesAccess,
            selectedTemplateTypeFilter,
            templateTypesAccess,
        } = this.state;

        return (
            <>
                <Grid container justify="space-between" alignItems="center" className={classes.headerTT}>
                    <Grid item xs="auto">
                        <Typography
                            onClick={() => { this.handleBack() }}
                            color="textPrimary"
                            variant="body1"
                            className={classes.cursorPointer}
                        >
                            <BackIcon classes={{ root: classes.backIconRoot }} />
                            Back to {this.state.backTo}
                        </Typography>
                    </Grid>
                </Grid>
                <Typography variant="h5" component="div" color="textSecondary" className={classes.container}>
                    <Typography className={classes.headingTxt}>Test Types and Templates</Typography>
                    <span className={classes.infoIcon}>
                        <CustomInfoIcon
                            infoDialogContentType="filters"
                            isInfoIcon={true}
                            isRightArrow={false}
                            isCenterArrow={true}
                            knowMoreAbout={true}
                            componentName="templatesetting"
                            dialogTitle="Test Types and Templates"
                            imageURL="/assets/svg/infoIcon/templateSettings/template.svg"
                            dialogPara="Create a new Test Type by clicking on the “Add New Test Type”. Once done, define the settings and create a template for that test type."
                            details="Click to know more"
                            toolTipDirection="top" />
                    </span>
                    <Grid container spacing={16}>
                        <Grid item xs={3}>
                            <Paper className={[classes.cardHeigth].join(',')}>
                                <TemplateTypes
                                    testTypesAccess={testTypesAccess} templateTypesAccess={templateTypesAccess} selectedTestTypeFilter={selectedTestTypeFilter} selectedTemplateTypeFilter={selectedTemplateTypeFilter} onFilterChanged={this.onFilterChanged.bind(this)}
                                    transferToParent={this.activeTestType.bind(this)} testTemplateType={testTemplateTypeList} changeCurrentTemplateType={this.changeCurrentTemplateType.bind(this)} updateTestTemplateTypeList={this.updateTestTemplateTypeList.bind(this)} />
                            </Paper>
                        </Grid>
                        {!!testTemplateTypeList.length && 
                        <Grid item xs={9}>
                            {/*testSectionLevel  
                            <TemplateSetting
                                activeTestType={selectedTestTypeName}
                                selectedTestSetting={selectedTestSetting}
                                transferToParent={this.activeTestSetting.bind(this)}
                                templatesList={filterTestTemplateList}
                                testTemplateType={testTemplateTypeList}
                                selectedId={selectedId}
                                updateTestTemplateTypeList={this.updateTestTemplateTypeList.bind(this)}
                                isFieldDisabled={this.isFieldDisabled}
                                settingDataSet={this.settingDataSet}
                                selectedTemplateTypeFilter={selectedTemplateTypeFilter}
                                selectedTestTypeFilter={selectedTestTypeFilter}
                            />*/}
                            <TemplateContent
                                skip={this.state.skip}
                                toPage={this.toPage}
                                recordCount={recordCount}
                                nextPage={this.handleNextPage}
                                prevPage={this.handlePrevPage}
                                transferToParent={this.activeTestType.bind(this)}
                                activeTestTypeId={selectedId}
                                templatesList={filterTestTemplateList}
                                isFieldDisabled={this.isFieldDisabled}
                                activeTSetting={selectedTestSetting}
                                testTemplateType={testTemplateTypeList}
                                updateTestTemplateTypeList={this.updateTestTemplateTypeList.bind(this)}
                                handleSearchQuery={this.handleSearchQuery}
                                searchQuery={this.state.searchQuery}
                                selectedTemplateTypeFilter={selectedTemplateTypeFilter}
                                onTemplateRuleEdit={this.onTemplateRuleEdit.bind(this)}
                            />
                        </Grid>
                        }
                    </Grid>
                </Typography>
            </>
        );
    }
}


const mapStateToProps = (state: any) => ({
    // map state to props here
    listTestTemplate: _.get(state, 'testTemplate.template.list', {}),
    testTemplateTypeList: _.get(state, 'testTemplate.testTemplateType.list', {}),
});



const mapDispatchToProps = (dispatch: any) => bindActionCreators(
    {
        getTypeOfGoal,
        getSubject,
        getContentSubType,
        getTestTemplateType,
        testTemplateList,
        setActiveTestType
    },
    dispatch
);


// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(TestTemplate));